export default __webpack_public_path__ + "c8c91598a5af8a2654aada92620471b6.jpg";